<template>
        <div class="bg-gray-50">
                <div class="w-full py-5 px-6">
                        <slot>
                                <div
                                        v-if="title || $slots.extra"
                                        class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4"
                                >
                                        <div class="flex-1">
                                                <h1 v-if="title" class="text-2xl font-semibold text-gray-900">
                                                        {{ title }}
                                                </h1>
                                                <p
                                                        v-if="subtitle"
                                                        class="mt-1 text-sm text-gray-500"
                                                >{{ subtitle }}</p>
                                        </div>
                                        <div
                                                v-if="$slots.extra"
                                                class="shrink-0"
                                        >
                                                <slot name="extra" />
                                        </div>
                                </div>
                        </slot>
                </div>
        </div>
</template>

<script>
export default {
        name: 'BasePageHeading',
        props: {
                title: {
                        type: String,
                        description: 'The title of page heading section',
                },
                subtitle: {
                        type: String,
                        description: 'The subtitle of page heading section',
                },
        },
};
</script>
